<template>
    <div>
        <card-header title="Attach Contact" icon="fa-search"/>

        <card-body>
            <card-list>
                <search-list-item @action="search"/>

                <container-list-item padded>
                    <b-field label="Filter by type" label-position="inside">
                        <b-select v-model="type" expanded @input="search(query)">
                            <option :value="null">All types</option>
                            <option v-for="t in types" :value="t.value" :key="t.value">{{t.label}}</option>
                        </b-select>
                    </b-field>
                </container-list-item>

                <!-- Before any search, lead with what this trip already uses.
                     That is where most attaches land -- the same driver on five
                     transfers -- and it is what keeps a global directory from
                     feeling like an address-book dump. -->
                <template v-if="!searched && suggestions.length">
                    <subheader-list-item icon="fa-tennis-ball" title="Used on this trip" :badge="suggestions.length"/>
                    <template v-for="contact in suggestions">
                        <contact-list-item
                            :card="card"
                            :contact="contact"
                            :key="'s' + contact.id"
                            @click="select(contact)"
                        />
                        <container-list-item padded v-if="selected && selected.id === contact.id" :key="'sf' + contact.id">
                            <attach-fields :link="link" @attach="attach"/>
                        </container-list-item>
                    </template>
                </template>

                <template v-if="searched">
                    <subheader-list-item icon="fa-address-book" :title="resultsTitle" :badge="results.length"/>
                    <template v-for="contact in results">
                        <contact-list-item
                            :card="card"
                            :contact="contact"
                            :key="'r' + contact.id"
                            @click="select(contact)"
                        />
                        <container-list-item padded v-if="selected && selected.id === contact.id" :key="'rf' + contact.id">
                            <attach-fields :link="link" @attach="attach"/>
                        </container-list-item>
                    </template>
                    <container-list-item padded v-if="!results.length">
                        <p class="has-text-grey is-size-7 my-2">No contacts match. Create a new one below.</p>
                    </container-list-item>
                </template>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <!-- Deliberately the last resort, not the first option: reaching
                 for search first is what stops the directory filling up with
                 six copies of the same restaurant. -->
            <b-button type="is-primary is-outlined" size="is-small" @click="createNew">
                <i class="fas fa-plus mr-2"></i>Create a new contact instead
            </b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardBody from "../../TIER/components/CardBody";
    import CardFooter from "../../TIER/components/CardFooter";
    import CardList from "../../TIER/components/CardList";
    import SearchListItem from "../../TIER/components/SearchListItem";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import ContactListItem from "@/components/ContactListItem";
    import AttachFields from "@/cards/contacts/AttachFields";
    import {client as http} from "../../http_client";
    import {TYPES} from "@/components/contact_meta";

    export default {
        components: {
            AttachFields, ContactListItem, ContainerListItem, SubheaderListItem,
            SearchListItem, CardList, CardFooter, CardBody, CardHeader
        },
        props: ['card', 'props'],
        data: function () {
            return {
                types: TYPES,
                type: null,
                query: '',
                suggestions: [],
                results: [],
                searched: false,
                selected: null,
                // Role/label chosen inline once a contact is picked -- a
                // two-field decision doesn't warrant a second card.
                link: {role: null, label: null}
            };
        },
        computed: {
            resultsTitle: function () {
                return this.query ? `Results for "${this.query}"` : 'All Contacts';
            }
        },
        methods: {
            loadSuggestions: function () {
                http.get(`/api/contacts/suggest/${this.props.entityType}/${this.props.entityId}`, {force: true})
                    .then(response => {
                        this.suggestions = response.data;
                    });
            },
            search: function (query) {
                this.query = typeof query === 'string' ? query : this.query;
                this.selected = null;

                const params = [];
                if (this.query) params.push('q=' + encodeURIComponent(this.query));
                if (this.type) params.push('type=' + encodeURIComponent(this.type));

                http.get('/api/contacts' + (params.length ? '?' + params.join('&') : ''), {force: true})
                    .then(response => {
                        this.results = response.data;
                        this.searched = true;
                    });
            },
            select: function (contact) {
                // Second click on the same row collapses the inline form.
                this.selected = (this.selected && this.selected.id === contact.id) ? null : contact;
                this.link = {role: null, label: null};
            },
            attach: function () {
                if (!this.selected) return;
                this.$emit('loading', true);

                http.post(`/api/contacts/entity/${this.props.entityType}/${this.props.entityId}`, {
                    contact_id: this.selected.id,
                    role: this.link.role,
                    label: this.link.label
                }, {force: true}).then(() => {
                    this.$closeCard(this.card);
                }).catch(() => {
                    this.$emit('loading', false);
                });
            },
            createNew: function () {
                this.$openCard('new-contact', {
                    entityType: this.props.entityType,
                    entityId: this.props.entityId
                }, this.card);
            }
        },
        mounted() {
            this.loadSuggestions();
        }
    };
</script>
